import React, { Component } from 'react';
import { Avatar, Badge, Button, Upload, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Field, FieldArray } from 'formik';
import { asyncConnect } from 'react-async-client';
import { withRouter } from 'react-router-dom';
import { path } from 'ramda';
import * as yup from 'yup';
import { CameraOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import request from 'rc-upload/lib/request';
import Compressor from 'compressorjs';

import Error from 'components/common/Error';
import Spinner from 'components/common/Spinner';
import withRole from 'components/common/withRole';
import HeadBlock from 'components/common/cards/HeadBlock';
import ArrayButton from 'components/common/form/ArrayButton';
import Text from 'components/common/form/Text';
import Select from 'components/common/form/Select';
import SaleDatePicker from 'components/common/form/SaleDatePicker';
import PageForm from 'components/common/PageForm';
import ArrowBack from 'components/common/ArrowBack';
import { UNABLE_ADD_PHOTO_WITHOUT_CHECKIN } from 'constants/serverMessages';
import {
    getPhotoReportTypes,
    getPhotoReportTypeSettings,
} from 'constants/photoReports';
import { FILE } from 'constants/urls';
import { getFileUrl } from 'utils/file';
import { getActionUrl } from 'utils/http';
import { getJWTToken } from 'utils/token';
import { checkError } from 'utils/error';
import {
    getPhotoReports,
    getCurrentCheckin,
    getPhotoReport,
    postPhotoReport,
    putPhotoReport,
    postFile,
    getPhotoReportSettings,
} from 'actions/asyncActions';
import { currentCheckinOptions, fullAutoOptions, formAutoOptions } from 'constants/asyncClient';
import { openPreviewModal } from 'actions/modalActions';

@withRole
@withRouter
@asyncConnect({
    getPhotoReport: getPhotoReport
        .withPayload(path(['match', 'params', 'id']))
        .withOptions(fullAutoOptions),
    getCurrentCheckin: getCurrentCheckin
        .withOptions(currentCheckinOptions),
    postAction: postPhotoReport.withOptions(formAutoOptions),
    putAction: putPhotoReport.withOptions(formAutoOptions),
    postFile: postFile
}, state => ({
    photoReportSettings: getPhotoReportSettings.selectData(state),
}), { openPreviewModal })
@asyncConnect({
    getPhotoReports: getPhotoReports
        .withPayload(({ getCurrentCheckin: { data } }) => ({
            q: {
                shop: data.shop,
                minDate: data.date,
            },
            limit: 2
        }))
        .withOptions(fullAutoOptions),
}, state => ({
    photoReportSettings: getPhotoReportSettings.selectData(state),
}), { openPreviewModal })
export default class PhotoReportsForm extends Component {
    constructor(props) {
        super();
    }

    onSubmitSuccess = () => {
        message.success('Отчет успешно обновлен.');

        this.props.history.push('/checkin');
    }

    onChangeUpload = push => info => {
        const { status, name } = info.file;
        switch (status) {
            case 'done':
                const { id } = info.file.response;
                message.success(`${name} файл успешно загружен.`);
                push({ id });
                break;
            case 'error':
                message.error(`Ошибка загрузки файла ${name}.`);
                break;
            default:
        }
    }

    customRequest = (config) => {
        new Compressor(config.file, {
            quality: 0.6,
            maxWidth: 1980,
            maxHeight: 1080,
            success(result) {
                config.file = result;
                request(config);
            }
        });
    }

    renderPhotoField = (name, label, disabled) => (
        <FieldArray name={name} render={({ form, push, remove }) => {
            return (
                <div>
                    <div className=''>
                        <div style={{marginBottom: 12}}>
                            <b>{label}<sup style={{color: 'red'}}>*</sup></b>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: 8 }}>
                            { (form.values[name] || []).map((photo, index) => (
                                <div>
                                    <Badge
                                        style={{ backgroundColor: '#304056', padding: 7, borderRadius: '50%' }}
                                        count={!disabled ? <CloseOutlined style={{ color: '#fff', fontSize: 10 }} /> : 0}
                                        onClick={() => !disabled && remove(index)}
                                    >
                                        <Avatar
                                            shape="square"
                                            size={{ xs: 100, sm: 110, md: 110, lg: 110, xl: 110, xxl: 110 }}
                                            src={getFileUrl(photo.id)}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.props.openPreviewModal(getFileUrl(photo.id));
                                            }}
                                        />
                                    </Badge>
                                </div>
                            ))}
                            { !disabled && (form.values[name].length < 10) && (
                                <div>
                                    <Field
                                        name={name}
                                        component={ArrayButton}
                                        button={(
                                            <Upload
                                                key={form.values[name] ? form.values[name].length : '0'}
                                                name={`file`}
                                                onChange={this.onChangeUpload(push)}
                                                customRequest={this.customRequest}
                                                multiple={false}
                                                action={getActionUrl(FILE)}
                                                accept='image/*'
                                                capture='camera'
                                                headers={{ Authorization : getJWTToken()}}
                                                showUploadList={false}
                                            >
                                                <Button
                                                    className='primary-dashed photo-button'
                                                    type='dashed'
                                                    block
                                                >
                                                    <br />
                                                    <CameraOutlined  style={{ fontSize: '30px' }} /><br />
                                                    Сделать фото<br />
                                                    <small>До 10 штук</small>
                                                </Button>
                                            </Upload>
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }} />
    )

    renderForm = formProps => {
        const { getPhotoReports: { data: reports }, isPromoter, getPhotoReport: { data: report }, getCurrentCheckin: { data }, photoReportSettings } = this.props;
        const active = data && data.status !== 'finished';
        const disabled = !!this.getId() ? report.date !== data.date || !active : false;
        const isEdit = !!this.getId();
        const hasDraft = reports.items && reports.items.length && reports.items.filter(item => item.date === data.date).find(item => item.type === formProps.values.type);
        const typeLabels = getPhotoReportTypeSettings(photoReportSettings, formProps.values.type);

        return (
            <div>
                <Field
                    name='date'
                    component={SaleDatePicker}
                    disabled={isPromoter}
                />
                <Field
                    name='type'
                    component={Select}
                    options={getPhotoReportTypes(photoReportSettings)}
                    placeholder='Выберите отчет'
                    allowClear={true}
                    disabled={isPromoter && (path(['match', 'params', 'type'], this.props) || this.getId())}
                />
                {formProps.values.type ? !isEdit && hasDraft ? (
                    <div>
                        <b>Отчет уже создан</b><br />
                        <Link to={`/photo/edit/${hasDraft.id}`}>
                            <Button>Перейти</Button>
                        </Link>
                    </div>
                ) : (
                    <div>
                        {this.renderPhotoField('photos', typeLabels.photosLabel, disabled)}
                        <Field
                            label={typeLabels.commentLabel}
                            name='comment'
                            component={Text}
                            disabled={disabled}
                            placeholder='Введите комментарий при необходимости'
                        />
                        {this.renderPhotoField('additionalPhotos', typeLabels.additionalPhotosLabel, disabled)}
                        <Field
                            label={typeLabels.additionalCommentLabel}
                            name='additionalComment'
                            component={Text}
                            disabled={disabled}
                            placeholder='Введите комментарий при необходимости'
                        />
                        { !disabled && (
                            <Button
                                className='pull-right'
                                type='primary'
                                htmlType='submit'
                                disabled={formProps.isSubmitting}
                                onClick={formProps.handleSubmit}
                            >
                                Сохранить
                            </Button>
                        )}
                    </div>
                ) : null}
                <br />
                <br />
                <div className='pull-clear' />
            </div>
        );
    };

    getValidationSchema() {
        const { isSupervisor } = this.props;

        return yup.object().shape({
            promoter: isSupervisor ? yup.string().nullable().required() : yup.string().nullable(),
            date: yup.date().nullable().required(),
            type: yup.string().nullable().required(),
            photo: yup.array().of(
                yup.object().shape({
                    id: yup.string().nullable().required(),
                })
            ).max(10, 'Максимум 10 фото'),
        });
    }

    getId() {
        return path(['match', 'params', 'id'], this.props);
    }

    getInitialValues(checkin, report, isEdit) {
        return isEdit ? {
            ...report,
            photos: (report.photos || []).map(id => ({ id })),
            additionalPhotos: (report.additionalPhotos || []).map(id => ({ id })),
        } : {
            type: path(['match', 'params', 'type'], this.props),
            date: checkin.date,
            promoter: checkin.promoter,
            shop: checkin.shop,
            photos: [],
            additionalPhotos: [],
        };
    }

    render() {
        const { getPhotoReport: { data: report, meta: reportMeta }, getCurrentCheckin: { data, meta }, postAction, putAction } = this.props;
        const active = data && data.status !== 'finished';
        const isEdit = !!this.getId();

        return (
            <div className='sales-form'>
                <ArrowBack />
                <HeadBlock title={isEdit ? '' : 'Заполнить фотоотчет'} hideBack />
                { reportMeta.pending || meta.pending ? (
                    <Spinner />
                ) : reportMeta.error || meta.error ? (
                    <Error meta={reportMeta.error || meta.error} />
                ) : (isEdit || (data.id && active)) ? (
                    <PageForm
                        initialValues={this.getInitialValues(data, report, isEdit)}
                        validationSchema={this.getValidationSchema()}
                        formAction={isEdit ? putAction : postAction}
                        renderForm={this.renderForm}
                        onSubmitSuccess={this.onSubmitSuccess}
                        onSubmitFail={checkError('date', UNABLE_ADD_PHOTO_WITHOUT_CHECKIN)}
                    />
                ) : (
                    'Нет активного чекина'
                )}
            </div>
        );
    }
}
